import React, { useMemo } from 'react';
import { getPlansByCategory, getPlanByName, Plan } from '../data/planData';
import { SmartAskAmountsInfo } from './SmartAskAmountsInfo';
interface PlanSelectorProps {
  selectedPlan: string | null;
  onSelectPlan: (planName: string) => void;
  includeEvents: boolean;
  includeVM: boolean;
  includeGO: boolean;
  onToggleEvents: () => void;
  onToggleVM: () => void;
  onToggleGO: () => void;
}
export function PlanSelector({
  selectedPlan,
  onSelectPlan,
  includeEvents,
  includeVM,
  includeGO,
  onToggleEvents,
  onToggleVM,
  onToggleGO
}: PlanSelectorProps) {
  const enterprisePlans = getPlansByCategory('Enterprise');
  // Check if selected plan includes Smart Ask Amounts
  const hasSmartAskAmounts = useMemo(() => {
    if (!selectedPlan) return false;
    const plan = getPlanByName(selectedPlan);
    if (!plan) return false;
    return plan.productFeatures.some(pf => pf.features.includes('Smart Ask Amounts'));
  }, [selectedPlan]);
  const renderPlanCard = (plan: Plan) => {
    const isSelected = selectedPlan === plan.name;
    return <button key={plan.name} onClick={() => onSelectPlan(plan.name)} className={`w-full text-left p-4 rounded-lg border-2 transition-all ${isSelected ? 'border-[#0047AB] bg-[#EFF6FF]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-267" data-mp="2w4vqyxsiptlt">
        <h4 className="text-base font-semibold text-gray-900 mb-1" data-id="element-268" data-mp="356vabwr099rx">
          {plan.name}
        </h4>
        <p className="text-sm text-gray-600" data-id="element-269" data-mp="3a4eo6vjsjkjc">{plan.description}</p>
      </button>;
  };
  return <div className="space-y-6" data-id="element-270" data-mp="3f1n5ktx47kjj">
      {/* Enterprise Plans */}
      <div data-id="element-271" data-mp="3jvj1zrxqczcl">
        <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-272" data-mp="3jvrgfo9i4cpw">Plans</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-273" data-mp="3nwbc0neff89x">
          {enterprisePlans.map(renderPlanCard)}
        </div>
      </div>

      {/* Add-ons Section */}
      {selectedPlan && <div className="pt-4 border-t border-gray-200" data-id="element-274" data-mp="1o1ybodvkszv">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-275" data-mp="1mqr1el81340">
            Add-ons (Optional)
          </h3>
          <p className="text-sm text-gray-600 mb-3" data-id="element-276" data-mp="1sswtsr7fs4n8">
            Events, Volunteer Management, and Gift Officer are available as
            add-ons to any plan
          </p>
          <div className="space-y-2" data-id="element-277" data-mp="27jvxpoxbu50h">
            <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer" data-id="element-278" data-mp="22qknrex7x84c">
              <input type="checkbox" checked={includeEvents} onChange={onToggleEvents} className="w-4 h-4 text-[#0047AB] border-gray-300 rounded focus:ring-[#0047AB]" data-id="element-279" data-mp="2gh6714ql3k2r" />
              <div data-id="element-280" data-mp="2lhkhsujkl84h">
                <span className="text-sm font-medium text-gray-900" data-id="element-281" data-mp="2lh2ghji1w3pp">
                  Events
                </span>
                <p className="text-xs text-gray-600" data-id="element-282" data-mp="w3p374ryn5cg">
                  Event management and registration
                </p>
              </div>
            </label>

            <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer" data-id="element-283" data-mp="32r6a6bk8srxk">
              <input type="checkbox" checked={includeVM} onChange={onToggleVM} className="w-4 h-4 text-[#0047AB] border-gray-300 rounded focus:ring-[#0047AB]" data-id="element-284" data-mp="37oy4fc8d0q4x" />
              <div data-id="element-285" data-mp="2xy3he5nahmif">
                <span className="text-sm font-medium text-gray-900" data-id="element-286" data-mp="2k0okkfupicgf">
                  Volunteer Management (VM)
                </span>
                <p className="text-xs text-gray-600" data-id="element-287" data-mp="2p0j8qbn3knxs">
                  Volunteer tracking and coordination
                </p>
              </div>
            </label>

            <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer" data-id="element-288" data-mp="2f12663356q61">
              <input type="checkbox" checked={includeGO} onChange={onToggleGO} className="w-4 h-4 text-[#0047AB] border-gray-300 rounded focus:ring-[#0047AB]" data-id="element-289" data-mp="8c5rorff8tod" />
              <div data-id="element-290" data-mp="29ar7cmy2ttlm">
                <span className="text-sm font-medium text-gray-900" data-id="element-291" data-mp="25bru8f26yqj3">
                  Gift Officer (GO)
                </span>
                <p className="text-xs text-gray-600" data-id="element-292" data-mp="20bchnppqhn26">
                  Portfolio management and tracking
                </p>
              </div>
            </label>
          </div>
        </div>}

      {/* Smart Ask Amounts Info */}
      {hasSmartAskAmounts && <SmartAskAmountsInfo data-id="element-293" data-mp="1lnj388cdwql6" />}
    </div>;
}